const urlParams = new URLSearchParams(window.location.search);
const agentId = urlParams.get('agent_id');
const statusEl = document.getElementById('status') as HTMLElement;

function setStatus(text: string, color: string = 'text-yellow-500'): void {
  statusEl.className = `text-sm font-mono ${color}`;
  statusEl.textContent = text;
}

if (!agentId) {
  setStatus("Error: No agent_id in URL", "text-red-500");
  const terminalEl = document.getElementById('terminal');
  if (terminalEl) {
    terminalEl.innerHTML = '<div class="p-4 text-red-400">Please provide ?agent_id=... in the URL</div>';
  }
  throw new Error("No Agent ID");
}

function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export { agentId, setStatus, sleep };
